import React from "react";
import { history } from './_helpers';

const FeatureDisabled = () => {

    const containerStyle = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        background: "smokewhite",
        padding: "20px",
    };

    const cardStyle = {
        backgroundColor: "White",
        padding: "40px 30px",
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        textAlign: "center",
        maxWidth: "400px",
        width: "100%",
        marginBottom:"22%"
    };

    const iconStyle = {
        fontSize: "3rem",
        marginBottom: "20px",
        color: "#FF6B6B",
    };

    const headingStyle = {
        fontSize: "2rem",
        color: "#333",
        marginBottom: "10px",
    };

    const messageStyle = {
        fontSize: "1rem",
        color: "#666",
        marginBottom: "20px",
    };

    const buttonStyle = {
        padding: "10px 20px",
        fontSize: "1rem",
        border: "none",
        borderRadius: "5px",
        backgroundColor: "#AE373B",
        color: "#fff",
        cursor: "pointer",
        transition: "background-color 0.3s ease",
    };

    const handleBackHome = () => {
        history.push('/vote');
    };

    return (
        <div style={containerStyle}>
            <div style={cardStyle}>
                <div style={iconStyle}>🚫</div>
                <h1 style={headingStyle}>Feature Disabled</h1>
                <p style={messageStyle}>
                    Sorry, this feature is currently disabled. Please check back later or
                    contact support for assistance.
                </p>                

                <button style={buttonStyle} onClick={handleBackHome}>
                    Go Back to Home Page
                </button>
            </div>
        </div>
    );
};

export default FeatureDisabled;